import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CloudsIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="#011A19"
    title={t`Clouds`}
    {...props}
  >
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M5.667 3C3.09 3 1 5.016 1 7.5c0 1.758 1.046 3.28 2.57 4.021l.068.035A4 4 0 0 0 5.47 12h6.03c1.932 0 3.5-1.512 3.5-3.375S13.432 5.25 11.5 5.25c-.571 0-1.115.14-1.592.375C9.17 4.078 7.548 3 5.667 3Z"
      fill="none"
    />
  </Icon>
);
